import React from "react";
import "../../Styles/certified/flyers.css";

export default function Finzly() {
  return (
    <>
      <div className="flyers-certified-details-section">
        <div className="flyers-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="flyers-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="flyers-certified-details-left">
            <img
              src="/Certified_Ribbon/flyers_rib.png"
              alt="Outstanding Workplaces Certified"
              className="flyers-certified-badge"
            />
            <div className="flyers-certified-company-names">
              <a href="https://www.flyerssoft.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/fly.png"
                alt="Walkzero Logo"
                className="flyers-certified-company-logo"
              />
            </a>
              <h1 className="flyers-certified-full-name">
              Flyers Soft Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="flyers-certified-details-right">
            <img
              src="/assets/flyers/flyers_7.jpg"
              alt="Finzly Office"
              className="flyers-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="flyers-certified-description">
          <h2>
            Why Flyers Soft Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            Flyers Soft is a fast-growing digital transformation and custom software development company specializing in innovative technology solutions for startups, SMEs, enterprises, and Fortune 500 organizations. Headquartered in India with a growing global presence, the company delivers customized software, mobile applications, cloud solutions, UI/UX design, AI/ML, AR/VR, DevOps, and enterprise technology services tailored to diverse business needs. <br /><br />
            Driven by a strong commitment to innovation, quality, and customer success, Flyers Soft empowers businesses to accelerate digital transformation, enhance operational efficiency, and achieve scalable growth through cutting-edge technology solutions. With a highly skilled team of technology experts and a client-centric approach, the organization has successfully delivered impactful digital products across multiple industries while building long-term strategic partnerships with its clients.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="flyers-certified-info-cards">
          <div className="flyers-certified-info-card">
            <div className="flyers-certified-info-title">COMPANY SIZE</div>
            <div className="flyers-certified-info-value">140 Employees</div>
          </div>
          <div className="flyers-certified-info-card">
            <div className="flyers-certified-info-title">INDUSTRY</div>
            <div className="flyers-certified-info-value">Information Technology (IT) Services & Consulting
</div>
          </div>
          <div className="flyers-certified-info-card">
            <div className="flyers-certified-info-title">CONNECT</div>
            <div className="flyers-certified-info-icons">
              <span className="flyers-certified-icon-round">
                <a href="https://www.flyerssoft.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="flyers-certified-icon-round">
                <a href="https://www.linkedin.com/company/flyerssoft/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="flyers-certified-icon-round">
                <a href="https://x.com/FlyersSoft" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="flyers-certified-info-card">
            <div className="flyers-certified-info-title">LOCATION (HQ)</div>
            <div className="flyers-certified-info-value">Chennai, TN</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="flyers-certified-recognition-section">
          <h2 className="flyers-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="flyers-certified-recognition-badge">
            <img
              src="/Certified_Ribbon/flyers_rib.png"
              alt="Outstanding Workplaces Certified"
              className="flyers-certified-recognition-image"
            />
          </div>
          <div className="flyers-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="flyers-certified-life-section">
          <h2 className="flyers-certified-life-title">
            Life at Flyers Soft Private Limited
          </h2>
          <div className="flyers-certified-life-gallery">
            <div className="flyers-certified-life-col">
              <img src="/assets/flyers/flyers_1.jpg" alt="Office 1" className="flyers-certified-life-img" />
              <img src="/assets/flyers/flyers_2.jpg" alt="Team 1" className="flyers-certified-life-img" />
            </div>
            <div className="flyers-certified-life-col flyers-certified-life-center">
              <img src="/assets/flyers/flyers_3.jpg" alt="Main Office" className="flyers-certified-life-img flyers-certified-life-img-large" />
            </div>
            <div className="flyers-certified-life-col">
              <img src="/assets/flyers/flyers_4.jpg" alt="Office 2" className="flyers-certified-life-img" />
              <img src="/assets/flyers/flyers_5.jpg" alt="Team 2" className="flyers-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
